import React, { useState, useEffect, useRef } from 'react';
import { getQueryParam } from '../utils/navigation';
import apiService from '../services/apiService';
import QRCode from 'qrcode';
import { useAuth } from '../contexts/AuthContext';
import Header from '../components/Header';
import PrintHeader from '../components/PrintHeader';
import PrintFooter from '../components/PrintFooter';
import axios from 'axios';

// Create a separate axios instance for public endpoints
const publicAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5003/api'
});

const Details = () => {
  const { user } = useAuth();
  const sheetId = getQueryParam('SHEETID');
  const [prenupData, setPrenupData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const qrCanvasRef = useRef(null);
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [qrCodeGenerated, setQrCodeGenerated] = useState(false);

  useEffect(() => {
    if (sheetId) {
      fetchPrenupData();
      fetchQRCodeUrl();
    } else {
      setError('رقم الاستمارة غير موجود');
      setLoading(false);
    }
  }, [sheetId]);

  useEffect(() => {
    if (!loading && qrCodeUrl && qrCanvasRef.current && !qrCodeGenerated) {
      setTimeout(() => {
        QRCode.toCanvas(qrCanvasRef.current, qrCodeUrl, {
          width: 110,
          height: 110,
          margin: 3,
          errorCorrectionLevel: 'H',
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        }, (error) => {
          if (error) {
            console.error('QR Code generation error:', error);
          } else {
            setQrCodeGenerated(true);
          }
        });
      }, 100);
    }
  }, [loading, qrCodeUrl, qrCodeGenerated]);

  const fetchPrenupData = async () => {
    try {
      // Use the public endpoint like PrintSheet does
      const response = await publicAxios.get(`/public/print/${sheetId}`);
      if (response.data.success) {
        setPrenupData(response.data.data);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setError('لم يتم العثور على البيانات');
      } else {
        setError('حدث خطأ في جلب البيانات');
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchQRCodeUrl = async () => {
    try {
      const response = await publicAxios.get('/public/settings/qr-code-url');
      if (response.data.success && response.data.data.qrCodeUrl) {
        setQrCodeUrl(response.data.data.qrCodeUrl);
      }
    } catch (error) {
      console.error('Error fetching QR code URL:', error);
    }
  };

  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getDate().toString().padStart(2, '0')}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getFullYear()}`;
  };

  const displayYesNo = (value) => {
    if (value === 'Y' || value === 'yes' || value === true || value === 1 || value === '1') return 'نعم';
    if (value === 'N' || value === 'no' || value === false || value === 0 || value === '0') return 'لا';
    return '';
  };

  const displayTestResult = (value) => {
    if (value === 'N' || value === 'negative' || value === '0' || value === 0) return 'غير متفاعل';
    if (value === 'Y' || value === 'positive' || value === '1' || value === 1) return 'متفاعل';
    return '';
  };

  const calculateAge = (birthDate) => {
    if (!birthDate) return '';
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  };

  const closeWindow = () => {
    window.close();
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">جاري تحميل البيانات...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
          <div className="text-red-600 mb-4">
            <svg className="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p className="text-lg font-medium">{error}</p>
          </div>
          <button
            onClick={closeWindow}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            إغلاق
          </button>
        </div>
      </div>
    );
  }

  // Extract prenup details from the response structure
  const prenup = prenupData?.prenupData || {};

  return (
    <div>
      <style dangerouslySetInnerHTML={{
        __html: `
         .navbar-nav {
            margin-right: 0px !important;
        }
        #footer .container-fluid {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        #footer {
            text-align: center;
        }
            #footer .container-fluid .images {
                margin-left: 250px;
            }
        @media (max-width: 1200px) and (min-width: 991px) {
            #footer .container-fluid .images {
                margin-left: 150px;
            }  
        }
        @media (max-width: 768px) {
            #footer .container-fluid .images {
                margin-left: 0px;
            }
            #footer .container-fluid {
                display: block;
            }
        }
          .pic {
            display: block;
          }
          main {
            background-image: url('/assets/images/bgTransparent.png');
            background-position: center top;
            background-repeat: no-repeat;
            background-size: contain;
            -webkit-print-color-adjust: exact;
          }
          body {
            font-family: 'Cairo',sans-serif;
          }

          .qr-code {
            max-width: 100px;
            max-height: 110px;
          }

          .circle-stamp {
            width: 100px;
            height: 100px;
            border: 1px solid #000;
            border-radius: 100px;
            margin: auto;
          }

          p, .form-check-label {
            font-size: 18px;
          }

          h2 {
            font-weight: bold;
          }

          @media print {
            h2 {
              font-size: 18px !important;
            }

            p {
              font-size: 16px !important;
            }

            .font14 {
              font-size: 16px !important;
            }
          }
        `
      }} />

      {user ? <Header /> : <PrintHeader />}

      <main role="main">
        <div>
          <header className="bg-header small-header"></header>

          <div className="container mt-5" id="TableDiv">
            <div className="row">
              <div className="col-3 font-weight-bold"><p style={{paddingTop: '40px'}}>تاريخ الإصدار : {formatDate(prenup.createdAt)}</p></div>
              <div className="col-4 font-weight-bold"><p style={{paddingTop: '40px'}}>اسم الوحدة: {prenup.unitName || ''}</p></div>
              <div className="col-3 font-weight-bold"><p style={{paddingTop: '40px'}}>المحافظة: {prenup.governorate || ''}</p></div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <h2>البيانات الأساسية</h2>

                <div>
                  <div className="row">
                    <div className="col-5">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>
                        الاسم : <span className="font-weight-bold">{prenupData?.fullName || ''}</span>
                      </p>
                    </div>
                    <div className="col-4">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>
                        {prenup.nationalityType === 'N' ? 'رقم جواز السفر' : 'الرقم القومى'} : <span className="font-weight-bold">{prenupData?.nationalId || ''}</span>
                      </p>
                    </div>
                    <div className="col-2">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>
                        النوع : <span className="font-weight-bold">{prenupData?.gender === 'male' ? 'ذكر' : 'أنثى'}</span>
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-5">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>الجنسية : <span className="font-weight-bold">{prenup.nationality || 'مصري'}</span></p>
                    </div>
                    <div className="col-4">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>
                        السن : <span className="font-weight-bold">{calculateAge(prenupData?.dateOfBirth) || ''}</span>
                      </p>
                    </div>
                    <div className="col-3">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>
                        رقم الهاتف : <span className="font-weight-bold">{prenupData?.phone || ''}</span>
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-5">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>العنوان بالبطاقة : <span className="font-weight-bold">{prenupData?.address || ''}</span></p>
                    </div>
                    <div className="col-6">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>
                        عنوان سكن الزوجية : <span className="font-weight-bold">{prenup.marriageAddress || ''}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <br />

              <div className="col-md-12">
                <h2>الفحوصات الطبية</h2>

                <div>
                  <div className="row">
                    <div className="col-4">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>الطول(سم) : <span className="font-weight-bold">{prenup.height || ''}</span></p>
                    </div>
                    <div className="col-4">
                      <p style={{fontFamily: 'cairo'}}>
                        الوزن(كجم) : <span className="font-weight-bold">{prenup.weight || ''}</span>
                      </p>
                    </div>
                    <div className="col-4">
                      <p style={{fontFamily: 'cairo', display:'flex'}}>
                        <span>BMI : </span>
                        <span className="font-weight-bold">{prenup.bmi || ''}</span>
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-4" id="RH">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>
                        RH : <span className="font-weight-bold">{prenup.rhFactor === 'Y' ? 'إيجابى' : prenup.rhFactor === 'N' ? 'سلبى' : ''}</span>
                      </p>
                    </div>
                    <div className="col-4">
                      <p style={{fontFamily: 'cairo'}}>
                        فصيلة الدم: <span className="font-weight-bold">{prenup.bloodType || ''}</span>
                      </p>
                    </div>
                    <div className="col-4">
                      <p style={{fontFamily: 'cairo', display:'flex'}}>
                        <span>Hb : </span>
                        <span className="font-weight-bold">{prenup.hemoglobin || ''}</span>
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-4" id="HBSAG">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>
                        HBsAg : <span className="font-weight-bold">{displayTestResult(prenup.hbsAg)}</span>
                      </p>
                    </div>
                    <div className="col-4" id="ANTIHIV">
                      <p style={{fontFamily: 'cairo'}}>
                        Anti-HIV : <span className="font-weight-bold">{displayTestResult(prenup.antiHIV)}</span>
                      </p>
                    </div>
                    <div className="col-4" id="ANTIHCV">
                      <p style={{fontFamily: 'cairo'}}>
                        Anti-HCV : <span className="font-weight-bold">{displayTestResult(prenup.antiHCV)}</span>
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-4">
                      <p style={{fontFamily: 'cairo'}}>
                        ضغط الدم : <span className="font-weight-bold">{prenup.bloodPressure || ''}</span>
                      </p>
                    </div>
                    <div className="col-4">
                      <p style={{fontFamily: 'cairo'}}>
                        نتيجة فحص السكر(العشوائى) : <span className="font-weight-bold">{prenup.randomGlucose || ''}</span>
                      </p>
                    </div>
                    <div className="col-4">
                      <p style={{fontFamily: 'cairo', display:'flex'}}>
                        <span>Filter Paper Barcode : </span>
                        <span className="font-weight-bold">{prenup.hvdBarcode || ''}</span>
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <p style={{direction: 'ltr', fontWeight: 'bold', textDecoration: 'underline', fontFamily: 'cairo', width: '100%', display: 'block', textAlign: 'left'}}>
                      Hb Electrophoresis :
                    </p>
                  </div>
                  <div className="row col-md-12" style={{direction:'ltr'}}>
                    <div className="col-md-2 form-group">
                      <label>
                        A : {prenup.hbElectrophoresisA || '0'} %
                      </label>
                      <div>
                        <div>
                          <label className="form-check-label">
                            <b>{prenup.hbElectrophoresisAStatus || 'Normal'}</b>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 form-group">
                      <label>
                        F : {prenup.hbElectrophoresisF || '0'} %
                      </label>
                      <div>
                        <div>
                          <label className="form-check-label">
                            <b>{prenup.hbElectrophoresisFStatus || 'Normal'}</b>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 form-group">
                      <label>
                        A2 : {prenup.hbElectrophoresisA2 || '0'} %
                      </label>
                      <div>
                        <div>
                          <label className="form-check-label">
                            <b>{prenup.hbElectrophoresisA2Status || 'Normal'}</b>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 form-group">
                      <label>
                        C : {prenup.hbElectrophoresisC || '0'} %
                      </label>
                      <div>
                        <div>
                          <label className="form-check-label">
                            <b>{prenup.hbElectrophoresisCStatus || 'Normal'}</b>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 form-group">
                      <label>
                        S : {prenup.hbElectrophoresisS || '0'} %
                      </label>
                      <div>
                        <div>
                          <label className="form-check-label">
                            <b>{prenup.hbElectrophoresisSStatus || 'Normal'}</b>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <h2>التاريخ المرضى</h2>

                <div>
                  <div className="row">
                    <div className="col-4" id="BLOODPRESSURE">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>
                        هل يوجد إصابة بمرض ضغط الدم : <span className="font-weight-bold">{displayYesNo(prenup.bloodPressureHistory)}</span>
                      </p>
                    </div>
                    <div className="col-4" id="DIABETIC">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>
                        هل يوجد إصابة بمرض السكر : <span className="font-weight-bold">{displayYesNo(prenup.diabeticHistory)}</span>
                      </p>
                    </div>
                    <div className="col-4" id="BLOODTRANSFER">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>
                        هل تم عمل نقل دم فى أخر 6 أشهر: <span className="font-weight-bold">{displayYesNo(prenup.bloodTransferHistory)}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <h2>بيانات الزوج/الزوجة</h2>

                <div>
                  <div className="row">
                    <div className="col-6">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>
                        {prenup.partnerNationalityType === 'N' ? 'رقم جواز سفر الطرف الاخر' : 'رقم قومى الطرف الاخر'} : <span className="font-weight-bold">{prenup.partnerNationalityType === 'N' ? (prenup.partnerPassportNumber || '') : (prenup.partnerNid || '')}</span>
                      </p>
                    </div>
                    <div className="col-6">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>
                        اسم الطرف الاخر:
                        <span className="font-weight-bold">{prenup.partnerName || ''}</span>
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" id="ISRELATED">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>
                        هل توجد قرابة مع الطرف الاخر :
                        <span className="font-weight-bold">{displayYesNo(prenup.isRelated)}</span>
                      </p>
                    </div>
                    <div className="col-5" id="PREMARRIAGE">
                      <p style={{fontFamily: 'cairo'}}>
                        هل يوجد زواج سابق : <span className="font-weight-bold">{displayYesNo(prenup.previousMarriage)}</span>
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" id="EXISTINGCHILDREN">
                      <p className="mr-3 font14" style={{fontFamily: 'cairo'}}>
                        هل يوجد اطفال من الزواج السابق : <span className="font-weight-bold">{displayYesNo(prenup.existingChildren)}</span>
                      </p>
                    </div>
                    <div className="col-5" id="GENETICDISEASES">
                      <p style={{fontFamily: 'cairo'}}>
                        هل يوجد لدى الاطفال اى امراض وراثية : <span className="font-weight-bold">{displayYesNo(prenup.geneticDiseases)}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <br />

              <div className="col-md-12">
                <div className="row">
                  <div className="col-sm-5 pt-3"><p className="mr-3 font14" style={{color:'red', fontSize:'14px'}}>*هذه الوثيقة صالحة لمدة ستة اشهر من تاريخ الإصدار</p></div>
                  <div className="col-sm-3"></div>
                  <div className="col-sm-4">
                    {qrCodeUrl ? (
                      <canvas
                        ref={qrCanvasRef}
                        className="qr-code img-thumbnail img-responsive"
                        width="100"
                        height="110"
                      />
                    ) : (
                      <img src="/assets/images/PreMarriageQR.png" className="qr-code img-thumbnail img-responsive" alt="QR Code" />
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-8"></div>
                  <div className="col-sm-4 mb-1"><p style={{color:'black', fontWeight:'bold', fontSize:'14px'}}>{prenup.documentNumber || ''}</p></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />

        <div className="text-center">
          <a href="#" className="btn btn-danger btn-md" id="closeBtn" onClick={(e) => { e.preventDefault(); closeWindow(); }}>
            <i className="fas fa-window-close"></i> إغلاق
          </a>
        </div>
      </main>

      <PrintFooter />
    </div>
  );
};

export default Details;
